var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal in",
      staticStyle: { display: "block" },
      attrs: { id: "later-overlay" },
    },
    [
      _c("div", {
        attrs: { id: "modal-background" },
        on: {
          click: function ($event) {
            return _vm.$emit("hideModal")
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
          },
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return _vm.$emit("hideModal")
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              )
                return null
              $event.preventDefault()
              return _vm.$emit("hideModal")
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header clearfix" }, [
            _c(
              "button",
              {
                staticClass: "exit-popup",
                attrs: { "aria-label": "Exit this popup" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("hideModal")
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-times" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "modal-body-content clearfix" },
              [_vm._t("default")],
              2
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }